import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "toggler",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.changeStatus && _ctx.changeStatus(...args))
  }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "toggle-track"
  }, null, -1 /* HOISTED */)), _createElementVNode("div", {
    class: "slider",
    style: _normalizeStyle({
      transform: _ctx.toggleStyle.transform,
      backgroundColor: _ctx.toggleStyle.background
    })
  }, [_renderSlot(_ctx.$slots, "default", {}, undefined, true)], 4 /* STYLE */)]);
}